<template>
  <div class="search-content" :style="{top: GLOBAL.currentEnvironment ? '0' : ''}">
    <Search
      ref="topSearch"
      class="search"
      placeholder="工单编号|生产物料|工序名称|批次编号"
      :isAdd="false"
      :isScreen="false"
      :isType="false"
    ></Search>
    <div class="formgroup">
      <span class="title">工单编号</span>
      <van-field v-model="params.orderCode" label="" placeholder="请输入" />
      <div class="bottomLine"></div>
      <span class="title">批次编号</span>
      <van-field v-model="params.batchCode" label="" placeholder="请输入" />
      <div class="bottomLine"></div>
      <span class="title">生产物料</span>
      <van-field v-model="params.goodsName" label="" placeholder="请输入" />
      <div class="bottomLine"></div>
      <span class="title">规格</span>
      <van-field v-model="params.spec" label="" placeholder="请输入" />
      <div class="bottomLine"></div>
      <span class="title">工序名称</span>
      <van-field v-model="params.processName" label="" placeholder="请输入" />
      <div class="bottomLine"></div>
      <span class="title">处理状态</span>
      <!-- <van-field-multiple-selection
        label=""
        placeholder="请选择"
        v-model="selectedList"
        :columns="options1"
        label-width="100"
        :option="{ label: 'text', value: 'value' }"
      /> -->
      <van-field-checkbox
        :supportClear="true"
        placeholder="请选择"
        v-model="selectedList"
        :columns="options1"
        :option="{ label: 'text', value: 'value' }"
      />
      <div class="bottomLine"></div>
      <span class="title">操作人</span>
      <van-field
        :is-link="!createdByName"
        readonly
        name="picker"
        v-model="createdByName"
        @click="ddthrVisible = true"
        placeholder="请选择"
      >
        <div
          slot="right-icon"
          v-show="!!createdByName"
          @click.stop="confirmDdtjr('', '', true)"
        >
          <img src="~@/assets/img/filedClear.png" alt="" style="width:0.16rem">
        </div>
      </van-field>
      <div class="bottomLine"></div>
      <span class="title">提交时间</span>
      <van-field
        :is-link="!createdTimeRead"
        readonly
        name="picker"
        v-model="createdTimeRead"
        @click="createdTimeBeginVisible = true"
        placeholder="请选择"
      >
        <div
          slot="right-icon"
          v-show="!!createdTimeRead"
          @click.stop="cancelCreatedStartTime"
        >
          <img src="~@/assets/img/filedClear.png" alt="" style="width:0.16rem">
        </div>
      </van-field>
    </div>
    <div class="search-bottom">
      <span class="btncancel" @click="cancel">重置</span>
      <span class="btnconfirm" @click="confirm">确定</span>
    </div>

    <!--提交开始时间 -->
    <van-popup v-model="createdTimeBeginVisible" position="bottom" :close-on-click-overlay='false'>
      <van-datetime-picker
        @confirm="confirmCreatedStartTime"
        @cancel="cancelCreatedStartTime"
        type="date"
        title="提交开始时间"
        v-model="minDate"
        :formatter="formatter"
      />
    </van-popup>
    <!--提交结束时间 -->
    <van-popup v-model="createdTimeEndVisible" position="bottom" :close-on-click-overlay='false'>
      <van-datetime-picker
        @confirm="confirmCreatedEndTime"
        @cancel="cancelCreatedEndTime"
        type="date"
        title="提交结束时间"
        :min-date="createEndMinDate"
        :formatter="formatter"
      />
    </van-popup>
    <!--提交结束时间 -->
    <van-popup v-model="handleTypeVisible" position="bottom">
      <van-picker
        :columns="options1"
        @cancel="handleCancel"
        @confirm="handleConfirm"
        show-toolbar
      />
    </van-popup>
    <contact-pickers
      :visible="ddthrVisible"
      :max="5"
      @closePicker="ddthrVisible = false"
      @confirm="confirmDdtjr"
    >
    </contact-pickers>
  </div>
</template>

<script>
const formP = {
  operateId: "",
  handleStatus: "",
  applyTimeBegin: "",
  applyTimeEnd: "",
};
import Navbar from "@/components/navBar/navBar_right";
import ContactPickers from "@/components/choiceuse/ContactPickers";
import upload from "@/components/upload/upload";
import moment from "moment";
import Search from "@/components/search";
import VanFieldMultipleSelection from "@/components/ActionSheet/VanFieldMultipleSelection.vue";
import VanFieldCheckbox from "@/components/ActionSheet/VanFieldCheckbox";

export default {
  name: "search",
  components: {
    Navbar,
    ContactPickers,
    upload,
    Search,
    VanFieldMultipleSelection,
    VanFieldCheckbox
  },
  data() {
    return {
      title: this.$route.meta.title,
      ddthrVisible: false,
      createdTimeBeginVisible: false,
      createdTimeEndVisible: false,
      handleTypeVisible: false,
      fzrName: "", //生产负责人
      createdByName: "", //订单提交人
      rtitle: "",
      rname: "", //search
      minDate: new Date(),
      createEndMinDate: new Date(2020, 1, 1),
      promiseEndMinDate: new Date(2020, 1, 1),
      maxDate: new Date(2025, 10, 1),
      params: Object.assign({}, formP),
      createdTimeRead: "",
      handleTypeText: "",
      options1: [
        { text: "未开始", value: "notStart" },
        { text: "正在处理", value: "handling" },
        { text: "处理完成", value: "finish" },
      ],
      selectedList: [],
    };
  },
  props: {
    propsForSon: {
      type: Object,
      default: {},
    },
  },
  watch: {
    propsForSon(newVal) {
      console.log(newVal, "newValnewVal");
      this.$refs.topSearch.value = newVal.keyword;
      this.params.handleStatus = newVal.handleStatus;
      this.selectedList = newVal.handleStatus.split(",");
      this.handleTypeText = newVal.handleTypeText;
      this.createdTimeRead = newVal.createdTimeRead;
    },
  },
  computed: {},
  mounted() {},
  created() {},
  methods: {
    handleConfirm(v, i) {
      this.handleTypeText = v.text;
      this.params.handleStatus = v.value;
      this.handleTypeVisible = false;
    },
    handleCancel() {},
    fileChange(ids) {
      console.log("父组件" + ids);
    },
    // 选择提交开始时间
    confirmCreatedStartTime(date) {
      this.createEndMinDate = date;
      this.params.applyTimeBegin = moment(date)
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.params.applyTimeEnd = ""; // 切换开始时间后直接置空结束时间重新选择
      this.createdTimeBeginVisible = false;
      this.createdTimeEndVisible = true;
      this.createdTimeRead = moment(date).format("YYYY-MM-DD");
    },
    // 取消提交开始时间
    cancelCreatedStartTime() {
      this.params.applyTimeBegin = "";
      this.params.applyTimeEnd = "";
      this.createdTimeRead = "";
      this.createdTimeBeginVisible = false;
    },
    // 选择提交结束时间
    confirmCreatedEndTime(date) {
      this.params.applyTimeEnd = moment(date)
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss");
      this.createdTimeEndVisible = false;
      this.createdTimeRead =
        this.createdTimeRead + "~" + moment(date).format("YYYY-MM-DD");
    },
    // 取消提交结束时间
    cancelCreatedEndTime() {
      this.params.applyTimeBegin = "";
      this.params.applyTimeEnd = "";
      this.createdTimeRead = "";
      this.createdTimeEndVisible = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      if (type === "hour") {
        return val + "时";
      }
      if (type === "minute") {
        return val + "分";
      }
      return val;
    },
    confirmDdtjr(val, selectedList, judge) {
      this.params.operateId = "";
      this.createdByName = "";
      if (judge) {
        this.ddthrVisible = false;
        return;
      }
      this.params.operateId = val ? val : ""; //人员id
      let arr = [];
      if (selectedList) {
        selectedList.forEach((item) => {
          arr.push(item.realname);
        });
      }
      this.createdByName = arr.join(",");
      this.ddthrVisible = false;
    },
    cancel() {
      this.$refs.topSearch.value = "";
      this.createdByName = "";
      this.createdTimeRead = "";
      this.handleTypeText = "";
      this.selectedList = [];
      this.minDate = new Date();
      this.params = Object.assign({}, formP);
    },
    confirm() {
      this.params.handleTypeText = this.handleTypeText;
      this.params.handleStatus = this.selectedList.join(",");
      let obj = {
        ...this.params,
        createdTimeRead: this.createdTimeRead,
      };
      var keyword = this.$refs.topSearch.value;
      this.$emit("getCategory", obj, keyword);
    },
  },
};
</script>
<style lang="scss" scoped>
.search-content {
  //  padding-bottom: 0.5rem;
  position: fixed;
  top: 0.35rem;
  width: 100%;
  height: 100vh;
  background: #f5f5f5;
  z-index: 99;
  .formgroup {
    // height: calc(100vh - 1.11rem);
    padding-bottom: 0.53rem;
    overflow-y: scroll;
    background: #ffffff;
    // padding: 0 0.16rem;
    margin-top: 0.1rem;
    margin-bottom: 0.2rem;
    padding-top: 0.1rem;

    .title {
      width: 0.58rem;
      height: 0.14rem;
      font-size: 0.15rem;
      font-family: PingFang SC;
      font-weight: 400;
      color: #191f25;
      line-height: 0.05rem;
      margin-left: 0.16rem;
    }
  }
  .search-bottom {
    height: 0.5rem;
    width: 100%;
    background: #ffffff;
    // background: red;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    bottom: 0px;
    padding: 0.11rem;
    font-size: 0.16rem;
    .btnconfirm {
      width: 1.72rem;
      height: 0.39rem;
      background: #1890ff;
      color: #fff;
      border-radius: 0.03rem;
      text-align: center;
      line-height: 0.39rem;
    }
    .btncancel {
      width: 1.72rem;
      height: 0.39rem;
      background: #f6f6f6;
      color: #191f25;
      // border: 0.01px solid rgba(25, 31, 37, 0.12);
      border-radius: 0.03rem;
      text-align: center;
      line-height: 0.39rem;
    }
  }
}
.bottomLine {
  height: 0.01rem;
  background-color: #f0f0f0;
  margin: 0 0.16rem 0.14rem;
}
</style>